module.exports = __webpack_public_path__ + "img/okx_grey_new.3bdd8c51.svg";